/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_PastInputs */

const en_capture_past = /** @type {(inputs: Capture_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This lesson already happened — it will be recorded as completed.`)
};

const he_capture_past = /** @type {(inputs: Capture_PastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`השיעור הזה כבר התקיים — הוא יירשם כהושלם.`)
};

/**
* | output |
* | --- |
* | "This lesson already happened — it will be recorded as completed." |
*
* @param {Capture_PastInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_past = /** @type {((inputs?: Capture_PastInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_PastInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_past(inputs)
	return he_capture_past(inputs)
});